<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/>
<g>
	<path style="fill:#0052B4;" d="M256,0C154.506,0,66.81,59.065,25.402,144.696h461.195C445.19,59.065,357.493,0,256,0z"/>
	<path style="fill:#0052B4;" d="M256,512c101.493,0,189.19-59.065,230.598-144.696H25.402C66.81,452.935,154.506,512,256,512z"/>
</g>
<polygon style="fill:#FFDA44;" points="204.59,267.13 256,178.087 307.41,267.13 "/>
<polygon style="fill:#6DA544;" points="322.783,296.531 256,329.923 189.217,296.531 189.217,252.01 322.783,252.01 "/>
<path style="fill:#FFDA44;" d="M318.963,181.907l-23.611,23.611c10.071,10.071,16.301,23.984,16.301,39.352
	c0,30.736-24.917,55.652-55.652,55.652s-55.652-24.917-55.652-55.652c0-15.368,6.23-29.281,16.301-39.352l-23.611-23.611
	c-16.115,16.112-26.081,38.373-26.081,62.963c0,49.178,39.866,89.043,89.043,89.043s89.043-39.866,89.043-89.043
	C345.043,220.28,335.077,198.019,318.963,181.907z"/>
</svg>